import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { Table, Layout, Space, Row, Col, Button, FloatButton } from "antd";
import dayjs from "dayjs";
import { PlusCircleOutlined, EditOutlined, EyeFilled } from "@ant-design/icons";

import { usePaginate } from "backend/usePaginate";
import { useBackend } from "backend/useBackend";
import SearchBy from "components/SearchBy";
import PageLimitDropDown from "components/PageLimitDropDown";
import { DeleteConfirm } from "cms/components/DeleteConfirm";

var localizedFormat = require("dayjs/plugin/localizedFormat");

dayjs.extend(localizedFormat);
const { Content } = Layout;

const endpoint = "authors";
// const where = ['status', "==", 'initiated']

const Authors = () => {
  const tableRef = useRef();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [list, setList] = useState([]);
  const { deleteItem } = useBackend();
  const [showMore, setShowMore] = useState(true);

  const { loading, loadingMore, hasMore, items, loadMore, deleteById } =
    usePaginate(endpoint);

  useEffect(() => {
    setList(items);
  }, [items]);

  const setResult = async (list, searchLength) => {
    if (searchLength > 1) {
      setList(list);
      setShowMore(false);
    } else {
      setList(items);
      setShowMore(true);
    }
  };

  const columnsSearchable = [
    {
      key: "firstName",
      title: "First Name",
      searchable: true, // this is used for searchBy component
    },
    {
      key: "lastName",
      title: "Last Name",
      searchable: true, // this is used for searchBy component
    },
    {
      key: "nationality",
      title: "Nationality",
      searchable: true, // this is used for searchBy component
    },
  ];

  const columns = [
    {
      title: "Slug",
      dataIndex: "slug",
      key: "slug",
    },
    {
      title: "Name",
      dataIndex: "fullName",
      key: "fullName",
      sorter: (a, b) =>  {
        if (a.fullName < b.fullName) {
          return -1;
        }
        if (a.fullName > b.fullName) {
          return 1;
        }
        return 0;
      },
      sortDirections: ["ascend", "descend"],
      render: (fullName, row) => (
        <div>
          <strong>{fullName}</strong><br />
          <span>{row?.nationality}</span> {row?.occupation && <span>- {row?.occupation}</span>}
        </div>
      ),
    },
    // {
    //   title: "Name",
    //   dataIndex: "firstName",
    //   key: "firstName",
    //   // filters: {},
    //   // sorter: true,
    //   sortDirections: ["ascend", "descend"],
    //   render: (firstName, row) => (
    //     <span>
    //       {firstName} {row?.lastName}
    //     </span>
    //   ),
    // },
    {
      title: "Life Span",
      dataIndex: "dob",
      key: "dob",
      responsive: ["md"],
      // sortDirections: ["ascend", "descend"],
      render: (dob, row) => (
        <span>
          <div>{dob && `B: ${dayjs(dob).format("L")}`}</div>
          <div>{row?.died && ` D: ${dayjs(row?.died).format("L")}`}</div>
        </span>
      ),
    },
    // {
    //   title: "Nationality",
    //   dataIndex: "nationality",
    //   key: "nationality",
    //   // filters: {},
    //   // sorter: true,
    //   responsive: ["md"],
    //   // sortDirections: ["ascend", "descend"],
    // },
    {
      title: "About",
      dataIndex: "about",
      key: "about",
      className: "w-20",
      responsive: ["md"],
      // render: (about) => <div>{String(about).substring(0, 50)}</div>,
      ellipsis: true,
    },
    {
      title: "Quote Counts",
      dataIndex: "counts",
      key: "counts",
      align: "right",
      responsive: ["md"],
    },
    {
      title: "Last Updated At",
      dataIndex: "updatedAt",
      key: "updatedAt",
      align: "right",
      render: (updatedAt) => (
        dayjs(updatedAt).format("L LT")
      ),
    },
    // {
    //   title: "Date",
    //   dataIndex: "createdAt",
    //   key: "createdAt",
    //   align: "right",
    //   render: (createdAt, row) => (
    //     <>
    //       <div>Created: {dayjs(createdAt).format("L LT")}</div>
    //       <div>Update: {dayjs(row.updatedAt).format("L LT")}</div>
    //     </>
    //   ),
    // },
    // {
    //   title: "Created",
    //   dataIndex: "createdAt",
    //   key: "createdAt",
    //   render: (createdAt) => dayjs(createdAt).format("L LT"),
    // },
    // {
    //   title: "Updated",
    //   dataIndex: "updatedAt",
    //   key: "updatedAt",
    //   // render: (updatedAt, row) => updatedAt.toString()
    //   render: (updatedAt) => dayjs(updatedAt).format("L LT"),
    // },
    {
      title: "Actions",
      className: "table-actions",
      dataIndex: "id",
      key: "id",
      align: "right",
      render: (id, row) => (
        <Space size="middle">
          <EyeFilled
            onClick={() => navigate(`${pathname}/view/${id}`, { state: row })}
          />
          <EditOutlined
            onClick={() => navigate(`${pathname}/edit/${id}`, { state: row })}
          />
          <DeleteConfirm
            onConfirm={() =>
              deleteItem(endpoint, row.id, {
                redirectTo: endpoint,
                msg: {
                  loading: "Deleting...",
                  success: "Deleted successfully.",
                },
                loading: true,
              }).then(() => deleteById(row.id))
            }
          />
        </Space>
      ),
    },
  ];

  const onChange = (data) => {
    console.log(data);
  };

  return (
    <Content>
      <FloatButton
        icon={<PlusCircleOutlined />}
        type="primary"
        tooltip="Add New"
        onClick={() => navigate(`${pathname}/add`)}
      />
      <Row justify="space-between" style={{ marginBottom: "1em" }}>
        <Col xs={18} lg={12}>
          <Space>
            {/* <FilterByDate
              table={endpoint}
              column="transactionAt"
              setResult={setResult}
              stickyCondition={where}
            /> */}
            <SearchBy
              endpoint={endpoint}
              columns={columnsSearchable}
              setResult={setResult}
            />
          </Space>
        </Col>
        {/* <Col xs={6} lg={12} className="text-right"> */}
        {/* <Link to={`${pathname}/add`}>
            <Button type="primary">Add Item</Button>
          </Link> */}
        {/* </Col> */}
      </Row>
      <Table
        rowKey="id"
        dataSource={list}
        columns={columns}
        loading={loading}
        onChange={onChange}
        pagination={false}
        ref={tableRef}
      />
      <Row justify="space-between" style={{ marginTop: "1.5em" }}>
        <Col>
          <PageLimitDropDown />
        </Col>
        <Col>
          {showMore && hasMore && (
            <Button type="primary" onClick={loadMore} loading={loadingMore}>
              {loadingMore ? "Loading..." : "Load More"}
            </Button>
          )}
        </Col>
      </Row>
    </Content>
  );
};

export default Authors;
